import { useEffect, useState } from "react";
import { Layout } from "../src/components/Layout";
import { LoadingPage } from "../src/components/LoadingPage";
import { saveAuthRedirect } from "../src/utils/authRedirectStorage";
import LoginPage from "./login";

// Routes that are part of the auth pipeline itself. Stashing them as a
// deep-link target would create loops (e.g. land on /login -> stash /login
// -> Redirect.tsx navigates to /login -> land on /login -> ...).
const AUTH_PIPELINE_PATHS = new Set([
  "/",
  "/login",
  "/login/",
  "/redirect",
  "/redirect/"
]);

const IndexPage = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // When the CDN serves index.html as a SPA fallback for a URL like
    // /dashboard or /studio, the original path survives on window.location
    // even though Next.js has hydrated the index route. Stash the intended
    // URL so Redirect.tsx can navigate to it after the auth flow completes,
    // mirroring what Page.tsx does for unauthenticated deep-link visits.
    const { pathname, search } = window.location;
    if (!AUTH_PIPELINE_PATHS.has(pathname)) {
      const query: Record<string, string> = {};
      new URLSearchParams(search).forEach((value, key) => {
        query[key] = value;
      });
      saveAuthRedirect({ pathname, query });
    }
    setIsReady(true);
  }, []);

  if (!isReady) {
    return <LoadingPage />;
  }

  return (
    <Layout>
      <LoginPage />
    </Layout>
  );
};

export default IndexPage;
